import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountCompany } from '../../../models/account-company.model';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ILookup,
  ICountry,
  SecurityService,
  ProviderType,
  FullPageMaskService,
  ErrorReportingService,
  BannerMessageDetails,
  BannerMessageSeverity,
} from 'common';
import { CompanyService } from '../../../services/company.service';
import { Subject, map, takeUntil } from 'rxjs';

@Component({
  selector: 'acc-account-details-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit, OnDestroy {
  organisationTypes: ILookup[];
  salutations: ILookup[];
  countries: ICountry[];
  counties: ILookup[];
  company: AccountCompany;
  canEdit = true;
  componentUnderEdit: string = '';
  companyDetailsValidated: boolean = true;
  validationBanner: Array<BannerMessageDetails>;

  get providerTypeString(): string {
    return this.security.profile.selectedAccount?.providerTypeString;
  }

  private _destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private security: SecurityService,
    private companyService: CompanyService,
    private errorReportingService: ErrorReportingService,
    private maskService: FullPageMaskService
  ) {}

  ngOnInit() {
    this.organisationTypes = this.route.snapshot.data.organisationTypes;
    this.salutations = this.route.snapshot.data.salutations;
    this.countries = this.route.snapshot.data.countries;
    this.counties = this.route.snapshot.data.counties;
    this.company = this.route.snapshot.data.company;
    this.validationBanner = this.createValidationBanner();

    this.companyService.companySaved.pipe(takeUntil(this._destroy$)).subscribe((_) => this.router.navigate(['accounts']));

    if (this.security.profile.selectedAccount?.providerType === ProviderType.PRS) {
      this.companyService
        .getCompanyValidation()
        .pipe(takeUntil(this._destroy$))
        .subscribe((isValidated: boolean) => {
          this.companyDetailsValidated = isValidated;
        });
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  createValidationBanner(): Array<BannerMessageDetails> {
    const messages = [];
    const banner = new BannerMessageDetails();
    banner.title = 'Account Validation Required';
    banner.body =
      'Please check your account details carefully and if you are satisfied that they are all correct, please click the Validate button at the end of the page.';
    banner.severity = BannerMessageSeverity.warning;
    banner.icon = 'warning';
    messages.push(banner);
    return messages;
  }

  validateCompanyDetails(): void {
    this.maskService.showLoading();
    this.companyService
      .validateCompanyDetails()
      .pipe(takeUntil(this._destroy$))
      .subscribe((isValidated: boolean) => {
        if (isValidated) {
          this.companyDetailsValidated = isValidated;
          this.errorReportingService.displayInfo('Company details validated.');
        } else {
          this.errorReportingService.displayWarning('Validation issues. Please contact ComReg');
        }
        this.maskService.hideLoading();
      });
  }

  childIsEditing(componentUnderEdit: string) {
    this.componentUnderEdit = componentUnderEdit;
    this.canEdit = componentUnderEdit.length === 0;
  }
}
